<!--
 * @Author:MX
 * @Date: 2020-08-03 11:36:59
 * @LastEditTime: 2024-03-04 11:42:58
 * @Description: 服务管理-运费查询
-->
<template>
  <div class="freightInquiryContent main-wrap">
      <div class="form">
          <el-form :rules="rules" class="el-form-edit" :inline="true" :model="searchParam" ref="searchParam" label-position="left" label-suffix=" :">
               <el-col :span="4">
                   <el-form-item :label="senderProvince" prop="senderProvince">
                      <!-- <BaseAddress ref="senderProvinceSearch" :showLevel="3" v-model="searchParam.senderCity" @changeValue="changeValue"> </BaseAddress> -->
                      <el-select v-model="searchParam.senderProvince" filterable @change="dataProvinceChange($event,1)">
                        <el-option
                          v-for="item in provinceArray"
                          :key="item.id"
                          :label="item.nativeName"
                          :value="item.id"
                        />
                      </el-select>
                  </el-form-item>
               </el-col>
                <el-col :span="4">
                     <el-form-item :label="reciveProvince" prop="reciveProvince">
                       <el-select v-model="searchParam.reciveProvince" filterable @change="dataProvinceChange($event,2)">
                        <el-option
                          v-for="item in provinceArray"
                          :key="item.id"
                          :label="item.nativeName"
                          :value="item.id"
                        />
                      </el-select>
                         <!-- <BaseAddress ref="reciveProvinceSearch" :showLevel="3" v-model="searchParam.reciveCity" @changeValue="changeValue"> </BaseAddress> -->
                     </el-form-item>
                </el-col>
                <el-col :span="4">
                    <!-- <el-form-item :label="$lang('产品类型')" prop="type">
                          <el-input v-model="searchParam.type"></el-input>
                     </el-form-item> -->
                     <el-form-item :label="$lang('产品类型')" prop="expressType">
                        <Base-Select v-model="searchParam.expressType" :props="{label:'name',value:'code', res:'appProductTypeVOList',valueObj:true}"
                            dicUrl="/vip/baseData/list"  :placeholder="$lang('请选择')">
                        </Base-Select>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item :label="$lang('物品重量(kg)')" prop="num">
                          <el-input-number v-model="searchParam.num" :label="$lang('描述文字')" :precision="2" style="width:100%;" @change="handleChange" :min="1" :max="99999.99"></el-input-number>
                     </el-form-item>
                </el-col>
                <el-col :span="4">
                    <!-- <el-form-item :label="$lang('服务方式')" prop="service">
                         <el-input v-model="searchParam.service" disabled></el-input>
                     </el-form-item> -->
                     <el-form-item :label="$lang('服务方式')" prop="serviceMethodCode">
                          <!-- <el-input v-model="searchParam.service" disabled></el-input> -->
                          <Base-Select v-model="searchParam.serviceMethodCode" :props="{label:'name',value:'code',valueObj:true}"
                            dicUrl="/vip/baseData/serviceMethod/list"  :placeholder="$lang('请选择')" disabled>
                        </Base-Select>
                      </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item :label="$lang('支付方式')" prop="payment">
                        <!-- <Base-Select v-model="searchParam.payment" :dic="payTypesDic" :placeholder="$lang('请选择')"  :props="{label:'name' ,value:'code',valueObj:true}"></Base-Select> -->
                        <Base-Select v-model="searchParam.payment" :props="{label:'name',value:'code', res:'appPaymentMannerVOList',valueObj:true}"
                            dicUrl="/vip/baseData/list"  :placeholder="$lang('请选择')">
                        </Base-Select>
                     </el-form-item>
                </el-col>
                <br />
                <el-col :span="4">
                     <el-form-item :label="senderCity" prop="senderCity">
                       <el-select v-model="searchParam.senderCity" filterable @change="dataCityChange($event,1)">
                        <el-option
                          v-for="item in cityList"
                          :key="item.id"
                          :label="item.nativeName"
                          :value="item.id"
                        />
                      </el-select>
                         <!-- <BaseAddress ref="reciveProvinceSearch" :showLevel="3" v-model="searchParam.reciveCity" @changeValue="changeValue"> </BaseAddress> -->
                     </el-form-item>
                </el-col>
                <el-col :span="4">
                     <el-form-item :label="reciveCity" prop="reciveCity">
                       <el-select v-model="searchParam.reciveCity" filterable @change="dataCityChange($event,2)">
                        <el-option
                          v-for="item in cityList2"
                          :key="item.id"
                          :label="item.nativeName"
                          :value="item.id"
                        />
                      </el-select>
                         <!-- <BaseAddress ref="reciveProvinceSearch" :showLevel="3" v-model="searchParam.reciveCity" @changeValue="changeValue"> </BaseAddress> -->
                     </el-form-item>
                </el-col>
          </el-form>
          <div class="btns">
                <el-button type="primary" plain @click="resetSearch" class="h40 clear">{{ $lang('清空') }}</el-button>
                <el-button type="primary" @click="searchFun" :loading="loading" class="h40">{{ $lang('立即查询') }}</el-button>
          </div>

      </div>
      <h3>
          <span>{{ $lang('标准运费') }}：</span><span> {{ cost}}{{moneyType(countryCode)}}</span>
      </h3>
  </div>
</template>

<script type="text/javascript">
import { getComCost, getSettlement } from '@/api/module/customer'
import { RESPONSE_SUCCESS, DIC } from '@constants'
import { RULES } from '@utils/rules'
import * as Api from '@api/base/public'
export default {
  name: 'FreightInquiry',
  data() {
    return {
      isShowFirst: false,
      loading: false,
      DIC,
      COM_HTTP: {
        reqList: getComCost,
      },
      provinceArray: [], // 酋长国
      cityList: [], // 区域
      cityList2: [],
      endAddressId: '',
      startAddressId: '',
      searchParam: {
        senderProvinceId: '',
        senderProvince: '',
        senderCityId: '',
        senderCity: '',
        reciveProvinceId: '',
        reciveProvince: '',
        reciveCityId: '',
        reciveCity: '',
        reciveName: '',
        num: 1,
        type: this.$lang('标准快递'),
        serviceMethodCode: { id: '33', name: 'Pick Up', code: '01' },
        payment: { code: 'PP_PM', name: this.$lang('寄付月结'), id: 319, type: 'ZD106' }, // 支付方式
        expressType: { code: 'standard', name: this.$lang('Standard'), id: 93, lightThrowingCoefficient: 5000 }, // 产品类型
        productTypeCode: 'standard', // 产品类型code
        productTypeId: this.$lang('Standard'), // 产品类型name
      },
      cost: 0,
      rules: {
        senderProvince: [RULES.requiredSelect],
        reciveProvince: [RULES.requiredSelect],
        senderCity: [RULES.requiredSelect],
        reciveCity: [RULES.requiredSelect],
        num: [RULES.required],
        type: [RULES.required],
        serviceMethodCode: [RULES.required],
        payment: [RULES.required],
        expressType: [RULES.requiredSelect],
      },
      // payTypesDic: [{ code: 'PP_PM', name: this.$lang('寄付月结'), id: 319, type: 'ZD106' }, { code: 'PP_CASH', name: this.$lang('寄付现结'), id: 320, type: 'ZD106' }, { code: 'CC_CASH', name: this.$lang('到付现结'), id: 321, type: 'ZD106' }],
      // 21117,多国合一，根据用户的国家code，行政区域的label有变化，下面是沙特(原来)的行政区划
      senderProvince: this.$lang('寄件省份'),
      senderCity: this.$lang('寄件城市'),
      reciveProvince: this.$lang('收件省份'),
      reciveCity: this.$lang('收件城市'),
    }
  },
  created() {
    this.getProList()
  },
  computed: {
    countryCode() {
      return this.$store.state.base.user.countryCode || ''
    },
  },
  watch: {
    'countryCode': {
      handler(val) {
        const that = this
        if (val === 'UAE') {
          // 阿联酋的用户行政区域要变
          that.senderProvince = that.$lang('寄件酋长国')
          that.senderCity = that.$lang('寄件区域')
          that.reciveProvince = that.$lang('收件酋长国')
          that.reciveCity = that.$lang('收件区域')
        }
      },
      immediate: true,
    },
  },
  methods: {
    moneyType(type) {
      switch (type) {
        case 'UAE':
          return 'AED'
        case 'KSA':
          return 'SAR'
        case 'KWT':
          return 'KWD'
        case 'QAT':
          return 'QAR'
        case 'BHR':
          return 'BHD'
        case 'OMN':
          return 'OMR'
        case 'JOR':
          return 'JOD'
      }
    },
    handleChange() {},
    getParams(endAddressId, startAddressId) {
      const id = this.searchParam.payment.id || ''
      let smModeType = 2
      if (id) {
        switch (id) {
          case 320:
            smModeType = 1
            break
          case 319:
            smModeType = 2
            break
          case 321:
            smModeType = 3
            break
        }
      }
      console.log('this.searchParam', this.searchParam)
      return {
        endAddressId: this.endAddressId,
        startAddressId: this.startAddressId,
        number: this.searchParam.num,
        smMode: smModeType,
        productTypeCode: this.searchParam.expressType.code, // 产品类型code
        productTypeId: this.searchParam.expressType.id, // 产品类型name
        serviceMethodCode: this.searchParam.serviceMethodCode.code, // 服务方式code
      }
    },
    // 获取酋长国数据
    async getProList() {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 2 })
      if (code === RESPONSE_SUCCESS) {
        this.provinceArray = data
      } else {
        this.$message.error(msg)
      }
    },
    async dataProvinceChange(parentId, flag) {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 3, parentId: parentId })
      if (code === RESPONSE_SUCCESS) {
        if (flag === 1) {
          this.cityList = data
          this.searchParam.senderProvinceId = parentId
          this.searchParam.senderCityId = data[0].id
          this.searchParam.senderCity = data[0].nativeName
          let obj = {}
          obj = this.provinceArray.find((item) => {
            return item.id === parentId
          })
          this.searchParam.senderProvince = obj.nativeName
          this.changeValue(parentId, this.searchParam.senderCityId, flag)
        } else {
          this.cityList2 = data
          this.searchParam.reciveProvinceId = parentId
          this.searchParam.reciveCityId = data[0].id
          this.searchParam.reciveCity = data[0].nativeName
          let obj = {}
          obj = this.provinceArray.find((item) => {
            return item.id === parentId
          })
          this.searchParam.reciveProvince = obj.nativeName
          this.changeValue(parentId, this.searchParam.reciveCityId, flag)
        }
      } else {
        this.$message.error(msg)
      }
    },
    // 重置搜索
    resetSearch() {
      // this.$refs.senderProvinceSearch.clearInput()
      // this.$refs.reciveProvinceSearch.clearInput()
      this.searchParam.num = 1
      this.searchParam.senderProvinceId = ''
      this.searchParam.senderProvince = ''
      this.searchParam.senderCityId = ''
      this.searchParam.senderCity = ''
      this.searchParam.reciveProvinceId = ''
      this.searchParam.reciveProvince = ''
      this.searchParam.reciveCityId = ''
      this.searchParam.reciveCity = ''
      this.searchParam.expressType = '' // 产品类型
      // this.searchParam.serviceMethodCode =  { id: '33', name: 'Pick Up', code: '01' } //服务方式
    },
    async changeValue(provinceId, cityId, flag) {
      // const { provinceId, cityId, areaId } = curData
      // debugger
      if (!cityId) return
      const { data, code, msg } = await getSettlement({ providerId: provinceId, cityId })
      // console.log(data, code)
      if (code === RESPONSE_SUCCESS) {
        if (data) {
          const { id } = data
          if (provinceId === this.searchParam.senderProvinceId) { this.startAddressId = id }
          if (provinceId === this.searchParam.reciveProvinceId) { this.endAddressId = id }
        } else {
          if (flag === 1) {
            this.$message.warning('找不到寄件地址对应的结算目的地区域')
          } else {
            this.$message.warning('找不到收件地址对应的结算目的地区域')
          }
        }
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    dataCityChange(value, num) {
      // console.log(value)
      if (num === 1) {
        this.searchParam.senderCityId = value
        const obj = this.cityList.find((item) => {
          return item.id === value
        })
        this.searchParam.senderCity = obj.nativeName
        this.changeValue(this.searchParam.senderProvinceId, value)
      } else {
        this.searchParam.reciveCityId = value
        const obj = this.cityList2.find((item) => {
          return item.id === value
        })
        this.searchParam.reciveCity = obj.nativeName
        this.changeValue(this.searchParam.reciveProvinceId, value)
      }
    },
    async searchFun() {
    //   if (this.searchParam.senderCity === '') return this.$message.warning('寄件地址不能为空')
    //   if (this.searchParam.reciveCity === '') return this.$message.warning('收件地址不能为空')
    //   if (!this.startAddressId) return this.$message.warning('找不到寄件地址对应的结算目的地区域')
    //   if (!this.endAddressId) return this.$message.warning('找不到收件地址对应的结算目的地区域')
    //   if (!this.searchParam.payment) return this.$message.warning('支付方式不能为空')
      this.$refs.searchParam.validate((valid) => {
        if (valid) {
          const newParams = { ...this.getParams() }
          this.loading = true
          this.COM_HTTP.reqList(newParams).then(res => {
            const { code, msg, data } = res
            this.loading = false
            if (code === RESPONSE_SUCCESS) {
              this.cost = data.cost
              this.$message.success(this.$lang('查询成功！'))
            } else {
              this.$message.error(this.$lang(msg))
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.freightInquiryContent{
    padding: 24px;
    box-sizing: border-box;
    .form{
            background: #F7F7F9;
            border: 1px solid #EEEEEE;
            border-radius: 8px;
            padding:20px;
    }
    .btns{
        // text-align: center;
        width: 60%;
        padding-top: 75px;
        .clear{
            width: 112px;
        }
    }
    h3{
        font-size: 24px;
        text-align: center
    }
}
</style>
